import React, { PureComponent } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import LevelControl from '../LevelControl';
import LevelGame from '../LevelGame';

import * as routes from '../../constants/routes';

class Wrapper extends PureComponent {
  constructor() {
    super();
    this.state = {
      points: 0,
      level: 1,
      wrong: false,
      correct: false,
    };
  }

  handleAnswer = ({ isCorrect, nextLevel, nextGame, hasNext, lastQ }) => {
    if (isCorrect) {
      const correctSound = new Audio('/static/audio/correct-answer.mp3');
      correctSound.play();
      this.setState((prev) => {
        return { points: prev.points + 1, correct: true };
      });

      this.timeout = setTimeout(() => {
        if (hasNext) {
          this.props.history.push(`/level/${nextLevel}/${nextGame}`);
        }
        if (lastQ) {
          this.props.history.push(`/`);
        }
        this.setState({ correct: false });
      }, 1000);
    } else {
      const wrongSound = new Audio('/static/audio/wrong-answer.mp3');
      wrongSound.play();
      this.setState({ wrong: true });

      this.timeout = setTimeout(() => {
        this.setState({ wrong: false });
      }, 1000);
    }
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const { wrong, correct, points } = this.state;
    return (
      <Switch>
        <Route exact path={routes.MAIN} render={() => <LevelControl points={points} />} />
        <Route
          path={routes.LEVEL}
          render={() => <LevelGame handleAnswer={this.handleAnswer} wrong={wrong} correct={correct} points={points} />}
        />
        <Redirect to={routes.MAIN} />
      </Switch>
    );
  }
}

export default withRouter(Wrapper);
